<div [class.two-column-tool-tip]="_showInfo">
    <mat-form-field appearance="fill" [class.small]="_short">
        <mat-label>{{ _labelData.label }}</mat-label>
        <input matInput type="number" [name]="_name" (blur)="onBlur()" [required]="_required" [disabled]="_disabled" [(ngModel)]="_value" (ngModelChange)="valueUpdated($event)">
    </mat-form-field>
    @if (_showInfo) {
        <mat-icon color="primary" [matTooltip]="_toolTip" #tooltip="matTooltip" (click)="tooltip.toggle()">info</mat-icon>
    }
</div>